import React, { useState } from "react";
import { ButtonBase, makeStyles, Typography, Box } from "@material-ui/core";
import ReactSwipe from "react-swipe";

import Arrow from "./arrow.svg";
import ProductImage from "../ProductImage";
import LocalOfferPictoLong from "components/localOffer/assets/localOfferPictoLong_mobile.svg";
import { getProductEligibility } from "components/localOfferEligibility/LocalOfferEligibility";
import { OfferTag } from "ui/OfferTag/OfferTag";
import { isProductNew } from "../utils";
import { ProductStateTagWithInfo } from "ui/StateTag/StateTagWithInfo";

const Caroussel = ({ images, currentSlide, setCurrentSlide, classes, product }) => {
  let reactSwipeEl;

  return (
    <Box display="flex" flexDirection="column">
      <ReactSwipe
        className="carousel"
        swipeOptions={{
          continuous: true,
          startSlide: currentSlide - 1,
          transitionEnd: () => setCurrentSlide(reactSwipeEl.getPos() + 1),
        }}
        ref={(el) => (reactSwipeEl = el)}
      >
        {images.map((image, index) => {
          return (
            <div key={image}>
              <ProductImage
                src={image}
                maxWidth={600}
                product={product}
                number={index + 1}
                zoomOnMobile
                hideShape={true}
                offerTag={getProductEligibility(product) && <OfferTag label="" picto={LocalOfferPictoLong()} />}
                propagateError={undefined}
                placeholder={undefined}
                addBrightness={false}
                zoomOnDesktop={false}
                productStateTag={<ProductStateTagWithInfo isStateNew={isProductNew(product)} />}
              />
            </div>
          );
        })}
      </ReactSwipe>
      <Box display="flex" flexDirection="row" justifyContent="space-between">
        <Box zIndex={2} bottom={0} mb={1}>
          <ButtonBase onClick={() => reactSwipeEl.prev()}>
            <Arrow className={classes.arrowLeft} />
          </ButtonBase>
        </Box>
        <Box zIndex={2} bottom={0} mb={1}>
          <ButtonBase onClick={() => reactSwipeEl.next()}>
            <Arrow className={classes.arrowRight} />
          </ButtonBase>
        </Box>
      </Box>
    </Box>
  );
};

Caroussel.displayName = "Caroussel";

function ProductImageViewerMobile({ images, product }) {
  const classes = useStyle();
  const [currentSlide, setCurrentSlide] = useState(1);

  if (images.length === 0) {
    return (
      <ProductImage
        src=""
        maxWidth={600}
        product={undefined}
        propagateError={undefined}
        placeholder={undefined}
        addBrightness={false}
        zoomOnDesktop={false}
        zoomOnMobile={false}
        hideShape={false}
        offerTag={undefined}
        productStateTag={undefined}
      />
    );
  }
  return (
    <Box position="relative">
      <Caroussel
        currentSlide={currentSlide}
        images={images}
        product={product}
        setCurrentSlide={setCurrentSlide}
        classes={classes}
      />
      <Box position="absolute" width="100%" bottom={0} textAlign="center" clone>
        <Typography variant="body1" color="textPrimary">{`${currentSlide}/${images.length}`}</Typography>
      </Box>
    </Box>
  );
}

const useStyle = makeStyles((theme) => ({
  arrowRight: {
    fill: theme.palette.primary.main,
    width: 15,
    height: 15,
  },
  arrowLeft: {
    fill: theme.palette.primary.main,
    width: 15,
    height: 15,
    transform: "rotateZ(180deg)",
  },
}));

export default ProductImageViewerMobile;
